/* this file is transformed by vux-loader */
/* eslint-disable */
module.exports = function (file) {
  return require("@/views/".concat(file, ".vue")).default;
}; // vue-loader at least v13.0.0+